import { Pipe, PipeTransform } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as dayjs from 'dayjs';

@Pipe({
    name: 'ngbDateFormat',
})
export class NgbDateFormatPipe implements PipeTransform {
    transform(ngbDate: NgbDateStruct | null, short: boolean): string {
        if (!ngbDate) return '';

        const dayJsDate = this.transformNgbDateToDayJs(ngbDate);

        return short
            ? dayJsDate.format('DD MMM')
            : dayJsDate.format('ddd, DD MMM');
    }

    private transformNgbDateToDayJs = (date: NgbDateStruct): dayjs.Dayjs => {
        return dayjs(`${date.year}-${date.month}-${date.day}`);
    };
}
